import { render, staticRenderFns } from "./typeEditTabInformation.vue?vue&type=template&id=3de355ea&scoped=true&"
import script from "./typeEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./typeEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./typeEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de355ea",
  null
  
)

export default component.exports